import { appStoreUrl } from "../config/app-store-config";

const requireAppStoreLink = (documentScope: Document): HTMLAnchorElement => {
  const link = documentScope.getElementById("app-store-link");
  if (link === null) {
    throw new Error("App Store link is missing");
  }
  return link as HTMLAnchorElement;
};

export const installAppStoreLink = (
  documentScope: Document,
  native: boolean,
): HTMLAnchorElement => {
  const link = requireAppStoreLink(documentScope);
  link.hidden = native;
  if (native) {
    link.removeAttribute("href");
  } else {
    link.setAttribute("href", appStoreUrl);
  }
  return link;
};
